import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
    body {
      overflow: hidden;
      padding: 0;
      margin: 0;
      font-size: 16px;
      background-color: white;
      color: #314af3;
    }

    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
      font-family: nexa-lignt;
    }

    a {
      color: inherit;
      text-decoration: none;
    }

    a:hover {
      text-decoration: underline;
    }

    li {
      list-style: none;
    }

    button {
      background-color: white;
      border: 1px solid #314af3;
      border: none;
    }

    @font-face {
      font-family: "inter";
      src: url("../font/Inter.ttf");
    }
    @font-face {
      font-family: "nexa-bold";
      src: url("../font/Nexa\ Bold.otf");
    }
    @font-face {
      font-family: "nexa-lignt";
      src: url("../font/Nexa\ Light.otf");
    }
    @font-face {
      font-family: "gmarket-sans-lignt";
      src: url("../font/GmarketSansTTFLight.ttf");
    }
    @font-face {
      font-family: "gmarket-sans-medium";
      src: url("../font/GmarketSansTTFMedium.ttf");
    }
    @font-face {
      font-family: "gmarket-sans-bold";
      src: url("../font/GmarketSansTTFBold.ttf");
    }
`;

export default GlobalStyle;
